<template>
    <v-app-bar app :elevation="0" color="white" v-if="showAppBar">
        <v-app-bar-nav-icon @click.stop="navIconClick" color="secondary" />
        <v-toolbar-title>{{ $route.meta.title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn class="mr-4" to="/profile" depressed rounded v-if="isMobile"><v-icon left dark>fa-user-edit</v-icon></v-btn>
        <v-btn class="mr-4" to="/profile" depressed rounded v-else><v-icon left dark>fa-user-edit</v-icon> {{ user.first_name }} {{ user.last_name }}</v-btn>
        <v-btn color="secondary" v-if="!isMobile" depressed rounded @click="$emit('confirm-logout')">Logout</v-btn>
    </v-app-bar>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
    name: 'app-bar',
    data: () => ({
        drawer: true,
        miniVariant: false,
    }),
    computed: {
        ...mapState({
            user: state => state.user.user,
        }),
        showAppBar(){
            return this.$route.meta.appBarMobileOnly ? this.isMobile : true
        }
    },
    methods: {
        navIconClick(){
            this.$emit( 'nav-click' )
        }
    }
}
</script>

<style lang="scss" scoped>

</style>